var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.1ae20963dac2b4b77c631199f8c9e2af.svg#t';
                    var viewUrl = 'sprites.1ae20963dac2b4b77c631199f8c9e2af.svg#view-t';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };